import React, { useEffect, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader.js";
import {getLastSession,getLastUser,getDashboardInfo,setDashboardInfo,getCurrentDeviceSerial,setCurrentDeviceSerial} from '../../Data/SessionData.js';
import { createSession, loginUser, dashboardData, resetDevice } from '../../RestUtil.js';

export default function MySettings() {

  const [profileData, setProfileData] = useState(null);    
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState(""); 
  const [deviceSerial, setDeviceSerial] = useState("");
  const [dashData1, setDashData1] = useState(null);    
  const [currDeviceSerial, setCurrDeviceSerial] = useState(getCurrentDeviceSerial);

  useEffect(() => {
    var profileData = getLastUser();
    console.log("BE Data from MySettings", profileData);
    setProfileData( profileData );
    setEmail(profileData.emailAddress);
    setMobileNumber(profileData.mobileNumber===null?"":profileData.mobileNumber);
    setDeviceSerial(profileData.deviceSerial);
    var dashData2 = getDashboardInfo();
    console.log("BE Data from MySettings", dashData2);
    setDashData1( dashData2 );
  }, []);

  const deviceSerialChanged = (newSerial) => {
    console.log("Device Serial changed detected3 in Dashboard",newSerial);
    setCurrentDeviceSerial(newSerial);
    setCurrDeviceSerial(newSerial);
  }

  return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
          {dashData1 && 
            <PageHeader
              HeaderText="My Settings"
              Breadcrumb={[
                { name: "Home", navigate: "" },
                { name: "My Settings", navigate: "" },
              ]}
              LastUpdatedDate={dashData1.lastUpdatedDateTime} 
              deviceSerial={currDeviceSerial}
              callback={deviceSerialChanged}
            />
          }
            {/*
        <div>
        <form className="form-auth-small ng-untouched ng-pristine ng-valid">
        <div className="body">
          <h4>Reset Device Serial {deviceSerial}</h4>
          <div className="row clearfix">
            <div className="col-lg-6 col-md-12">
              <br/>
              Please note this will publish a messge to device to reset itself. This should be performed only when necessary and after all other options and precautions are considered. Hioctane Labs will not take any responsibilty for any loss of data in this case.
              <br/><br/>
            </div>
            <div className="col-lg-6 col-md-12">
            </div>
          </div>
          <button className="btn btn-primary" type="button" onClick={(e) => {
                  e.preventDefault();handleResetButton();
                }}
              >
            Reset Device
          </button>{" "}
        </div>
        </form>
              </div> */}
      </div>
      </div>
      </div>
    );
}
